"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    TokenType[TokenType["hnt"] = 0] = "hnt";
    TokenType[TokenType["hst"] = 1] = "hst";
    TokenType[TokenType["mobile"] = 2] = "mobile";
    TokenType[TokenType["iot"] = 3] = "iot";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
//# sourceMappingURL=types.js.map